import { Tooltip, withStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React from 'react';

const styles = (theme) => ({
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color: theme.gridTextColor
  },
  label: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    color: theme.disableButtonText
  },
  routeCount: {
    fontSize: theme.headerTextFontSize16,
    fontWeight: 600
  },
  routeCountPrimary: {
    color: theme.palette.primary.main
  },
  description: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor
  },
  trailerCount: {
    color: theme.disableButtonText
  }
});

const RouteSummaryItem = ({ details, label, isPrimary, info, classes }) => {
  const { trailers } = details;
  const trailersListLength = trailers.length;
  const trailerDetails = trailers.map((item, index) => (
    <span key={item.trailerName}>
      {item.trailerName} <span className={classes.trailerCount}>({item.count})</span>
      {index < trailersListLength - 1 ? ', ' : ''}
    </span>
  ));

  return (
    <div>
      <div className={classes.labelContainer}>
        <span className={`${classes.routeCount} ${isPrimary ? classes.routeCountPrimary : ''}`}>
          {details?.count}
        </span>
        <span className={classes.label}>{label}</span>
        {info && (
          <Tooltip title={info}>
            <InfoOutlinedIcon />
          </Tooltip>
        )}
      </div>
      <div className={classes.description}>
        Trailer used: <span>{trailerDetails}</span>
      </div>
    </div>
  );
};

export default withStyles(styles)(RouteSummaryItem);
